import { mapRequestProfile } from '~/lib/utils/dataMapping';
import { getServices } from '~/db/services';
import { getIsAppInstalled } from '~/lib/sync/isAppInstalled';

export type UseProfileLoadFromNetwork = {
  run: (
    autoUpdate?: boolean,
    forced?: boolean,
    showProgress?: boolean
  ) => Promise<{
    hasBeenRefreshed: boolean;
    error: any;
    status: number;
  }>;
};
export const useProfileLoadFromNetwork = (): UseProfileLoadFromNetwork => {
  const { $db } = useNuxtApp();

  const profile = useProfileStore();

  const dialog = useDialogStore();

  const context = useContextStore();

  const { importsService, profilesService } = getServices($db);

  const versions = useVersionsStore();

  const run = async (
    autoUpdate: boolean = true,
    forced: boolean = false,
    showProgress: boolean = false
  ): Promise<{
    hasBeenRefreshed: boolean;
    error: Error | null;
    status: number;
  }> => {
    const request = await useApiFetch(URI.Profile, {
      method: 'GET',
    });

    if (!request.error && request.status < 400) {
      const loadedDataProfile = request.result;
      const loadedProfile = mapRequestProfile(loadedDataProfile);

      const appIsInstalled = await getIsAppInstalled(
        $db,
        profile.contents,
        profile.isAdaptiveEnabled ?? false
      );

      if ((appIsInstalled && profile.data && autoUpdate) || forced) {
        await versions.getFromUserLoggedIn();
        if (versions.needForceFullUpdate()) {
          await importsService.clear();
          versions.reset();
          navigateTo('/installation');
        } else {
          if (showProgress) {
            useDialogProfileSync();
          }
          await useSyncStore().loadAndRun(
            loadedProfile,
            false,
            showProgress ? 10 : 1
          );
        }
      }

      await profilesService.put({
        id: context.memberId,
        data: loadedDataProfile,
      });

      profile.forceUpdateRawValue(loadedDataProfile);

      return { hasBeenRefreshed: true, error: null, status: request.status };
    } else {
      dialog.unlock();
      return {
        hasBeenRefreshed: false,
        error: request.error,
        status: request.status,
      };
    }
  };
  return {
    run,
  };
};
